// API Configuration
// In development (localhost), use localhost:8000 (or custom port for E2E tests)
// In production, use relative paths (empty string) - Nginx Ingress routes /api to the backend

const isLocalDev = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Allow override via environment variable (useful for E2E tests on different port)
const apiPort = process.env.REACT_APP_API_PORT || '8000';

// Force relative paths in production to avoid Mixed Content errors and IP issues
// We intentionally ignore process.env.REACT_APP_API_BASE_URL in production to avoid accidental IP baking
export const API_BASE_URL = isLocalDev ? `http://localhost:${apiPort}` : '';

// Helper function to build API endpoints
export const getApiUrl = (path) => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
